<template>
  <v-flex
    xs12
    sm4
    md3
    lg2
  >
    <v-card
      class="media-manager-item"
      height="95"
      flat
      rippleselected
      :draggable="true"
      :droppable="true"
      :class="dragClass + ' ' + selectedClass"
      @click="clicked"
      @dblclick="dblclicked"
      @contextmenu.prevent="showMenu"
      @dragover.prevent
      @drop="onDrop"
      @dragstart="onDragStart"
      @dragend="onDragEnd"
      @dragover="onDragOver"
      @dragleave="onDragLeave"
    >
      <v-card-title>
        <v-layout justify-center>
          <!-- VIDEO THUMBNAIL FEATURE -->
          <!--
          <video 
            v-else-if="(object.mime).includes('video')"
            height="40"
            muted
          >
            <source
              v-if="(object.ext).includes('mp4')"
              :src="object.path"
              type="video/mp4"
            >
            <source
              v-if="(object.ext).includes('webm')"
              :src="object.path"
              type="video/webm"
            >
          </video>
          -->
          <!-- PROJECT THUMBNAIL FEATURE -->
          <v-badge
            v-if="object.mime.includes('zip') && getThumbnail.length > 0"
            :icon="getIcon(object)"
            :color="getColor(object)"
            offset-x="10"
            offset-y="20"
          >
            <v-avatar
              size="55"
              tile
            >
              <v-img
                :src="getThumbnail"
                contain
              />
            </v-avatar>
          </v-badge>
          <!-- PICTURE THUMBNAIL FEATURE -->
          <v-img
            v-else-if="object.mime.includes('image')"
            :lazy-src="object.path"
            :src="object.path"
            contain
            height="40"
          />
          <v-icon
            v-else
            x-large
          >
            {{ getFiles([object.mime]) }}
          </v-icon>
        </v-layout>
      </v-card-title>
      <v-card-text :title="object.name">
        {{ object.name }}
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
// Connectors
import { ProjectConnector } from "../Database/ProjectConnector.js";

export default {
  components: {
    //
  },
  props: {
    object: {
      type: Object,
      required: true,
    },
    setDraggedItem: {
      type: Function,
      required: true,
    },
    endDrag: {
      type: Function,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      projectConnector: new ProjectConnector(this.$store.state.user),
      files: {
        "application/pdf": "mdi-file-pdf-box",
        "application/zip": "mdi-archive-settings",
        directory: "mdi-folder",
        file: "mdi-file-document",
        "image/png": "mdi-file-image",
        "image/jpg": "mdi-file-image",
        "video/mp4": "mdi-file-video",
      },
      messages: "",
      projectThumb: "",
      dragClass: "",
      dragging: false,
    };
  },
  computed: {
    getThumbnail() {
      if (this.projectThumb !== null && this.projectThumb !== undefined) {
        return this.projectThumb; // "./mediacenter/tmb/" + this.projectThumb //this.projectThumb;
      } else {
        return "";
      }
    },
    selectedClass() {
      let filter = this.selectedItems.filter((item) => item.id == this.object.id);
      return filter.length > 0 ? "multiselected" : "";
    },
  },
  created() {
    if (this.object.mime.includes("zip")) {
      this.setProjectThumbnail(this.object.path);
    }
  },
  methods: {
    setProjectThumbnail(val) {
      this.projectThumb = "";

      // TODO: STOP REPLACING / SPLITTING / JOINING...
      this.projectConnector
        .getInfoWithPath(val.replace(".\\", "").replace("./", "").split("\\").join("/"))
        .then((pid) => {
          this.projectThumb = "./mediacenter/tmb/" + pid + ".png?t=" + Date.now().toString();
        })
        .catch((err) => {
          if (!err.includes("not found")) {
            console.error(err);
          }
        });
    },
    getObjectPath() {
      // TODO: If used for thumbnail in mediamanager it will reload each time click in mediamanager
      return this.object.path + "?t=" + Date.now().toString();
    },
    getColor(object) {
      if (!object.scheduled) {
        return "success";
      } else {
        return "warning";
      }
    },
    getFiles(val) {
      if (this.files[val]) {
        return this.files[val];
      } else {
        return "mdi-file-question";
      }
    },
    getIcon(object) {
      if (!object.scheduled) {
        return "mdi-file-document-edit-outline";
      } else {
        return "mdi-clock-time-four-outline";
      }
    },
    clicked() {
      this.$emit("click", this.object);
    },
    dblclicked() {
      this.$emit("dblclick");
    },
    showMenu(event) {
      // On right click we select the media
      this.clicked();

      // check if right-clicked
      if (event.which === 3) {
        this.$emit("contextMenu", event);
      }
    },
    // eslint-disable-next-line no-unused-vars
    onDragStart(event) {
      this.setDraggedItem(this.object);
      this.dragging = true;
    },
    onDragEnd() {
      this.dragging = false;
    },
    onDragOver() {
      //indique si on peut drag un element sur cet element
      //seulement si c'est un "dir" (dossier) et que ce n'est pas l'élément qui est déjà en train d'être drag
      //pour ne pas déplacer un element sur lui-même
      this.dragClass = this.object.type == "dir" && !this.dragging ? "dragover" : "";
    },
    onDragLeave() {
      this.dragClass = "";
    },
    // eslint-disable-next-line no-unused-vars
    onDrop(event) {
      this.endDrag(this.object);
    },
  },
};
</script>

<style>
.media-manager-item.v-card {
  background-color: transparent;

  cursor: pointer;
  user-select: none;
}

.theme--dark.media-manager-item.v-card:hover {
  background-color: rgba(255, 255, 255, 0.06);
}

.selected .theme--dark.media-manager-item.v-card {
  background-color: rgba(255, 255, 255, 0.12);
}

.media-manager-item .v-card__title {
  height: 64px;
}

.media-manager-item .v-card__text {
  height: 1.5em;

  white-space: nowrap;
  overflow: hidden;

  text-align: center;
  text-overflow: ellipsis;
}

.theme--dark.media-manager-item.v-card.dragover {
  background-color: rgba(154, 195, 49, 0.493) !important;
}
.theme--light.media-manager-item.v-card.dragover {
  background-color: rgba(154, 195, 49, 0.493) !important;
}
.theme--dark.media-manager-item.v-card.multiselected {
  background-color: #2195f344 !important;
}
.theme--light.media-manager-item.v-card.multiselected {
  background-color: #2195f344 !important;
}

/* .dragover{
    box-shadow: 0px 0px 10px rgba(47, 145, 39, 0.7) !important;
  } */
</style>
